module.exports = __webpack_public_path__ + "static/media/803CCE99-4AFA-4E5C-9581-705F53956B74.d3d77c0c.jpeg";